import _ from 'lodash';

export const omitDeprecatedProps = (props, deprecatedProps = []) => {
  return _.omit(props, deprecatedProps);
};
